import { getUniversalUrl, URL_TYPE } from 'app/lib/get-universal-url';

import {
  MATCH_PERIODS_BY_SPORT,
  MATCH_TOTAL_SCORES_TYPE_BY_SPORT,
  SPORT_NAMES_BY_ID,
  SportId,
} from './constants';

/**
 * Get sport key by id or "default".
 */
export const getSportKey = (sportId: SportId): string => {
  return SPORT_NAMES_BY_ID[sportId] || 'other';
};

export const getSportIconUrl = (sportId?: SportId) => {
  const DEFAULT_SPORT_ICON_NAME = 'all-sports';
  const sportName = sportId ? SPORT_NAMES_BY_ID[sportId] : DEFAULT_SPORT_ICON_NAME;
  const path = `/icons/${sportName || DEFAULT_SPORT_ICON_NAME}.png`;

  return getUniversalUrl(path, URL_TYPE.PUBLIC);
};

export const getStreamIconUrl = (key: string) => {
  const path = `/icons/${key}.png`;

  return getUniversalUrl(path, URL_TYPE.PUBLIC);
};

export const hasPeriodsBySportId = (
  sportId: SportId,
): sportId is keyof typeof MATCH_PERIODS_BY_SPORT => {
  return sportId in MATCH_PERIODS_BY_SPORT;
};

export function hasScoresBySportId(
  sportId: SportId,
): sportId is keyof typeof MATCH_TOTAL_SCORES_TYPE_BY_SPORT {
  return sportId in MATCH_TOTAL_SCORES_TYPE_BY_SPORT;
}
